(ns practitest.frontend.components2.entity-form.base-control
  (:require
   [clojure.string :as str]
   [practitest.frontend.common.dom :as dom]))

(defn base-control
  [_] 
  (fn [{:keys [field-id
               get-field-state
               type
               label
               mandatory?
               title?
               read-only?]
        :as   props}
       editing-field
       readonly-field]
    (let [field-editing? (not read-only?)
          field-state @(get-field-state field-id)
          errors (:errors field-state)

          description? (= field-id :description)
          jira-issue-description? (= field-id :jira-issue-description)

          field-4? (or (= field-id :jira-project)
                       (= field-id :jira-issue-name))
          field-2? (and (not description?)
                        (not jira-issue-description?)
                        (not field-4?)
                        (contains? #{:memo :tags} type))
          field-1? (and (not description?)
                        (not jira-issue-description?)
                        (not field-4?)
                        (not field-2?)
                        (not (= :name field-id)))]
      [:div.g2-field-container
       {:class (dom/classes-pairs :readonly read-only?
                                  :editing field-editing?
                                  :description description?
                                  :jira-issue-description jira-issue-description?

                                  :fixed-width true

                                  :name-field (= :name field-id)
                                  :field-1 field-1?
                                  :field-2 field-2?
                                  :field-3 description?
                                  :field-4 field-4?)}

       (when (and (not title?)
                  (not description?))
         [:label.m-label {:for   field-id
                          :class (dom/classes-pairs-v
                                  :description description?)}
          label (when mandatory?
                  [:span.mandatory "*"])])

       [:div.input-with-message-container {:id field-id}
        (if field-editing?
          ;; Splice some props into child component
          (let [[component props & children] editing-field]
            [component
             (assoc props :errors errors)
             children])
          [:div.m-readonly-field {:id field-id}
           readonly-field])
        ;; Show errors for both read-only and editing fields (used in e.g. Jira edit modal)
        (when (seq errors)
          [:div.validation-error-message (str/join "," (mapv :message errors))])]])))
